// [standard annual, logging annual] per weight category (Form 2290 pg 2).
export const RATES = {
  A: [100, 75], B: [122, 91.5], C: [144, 108], D: [166, 124.5], E: [188, 141],
  F: [210, 157.5], G: [232, 174], H: [254, 190.5], I: [276, 207], J: [298, 223.5],
  K: [320, 240], L: [342, 256.5], M: [364, 273], N: [386, 289.5], O: [408, 306],
  P: [430, 322.5], Q: [452, 339], R: [474, 355.5], S: [496, 372], T: [518, 388.5],
  U: [540, 405], V: [550, 412.5],
};

export const WEIGHTS = {
  A: "55,000 lb", B: "55,001–56,000", C: "56,001–57,000", D: "57,001–58,000",
  E: "58,001–59,000", F: "59,001–60,000", G: "60,001–61,000", H: "61,001–62,000",
  I: "62,001–63,000", J: "63,001–64,000", K: "64,001–65,000", L: "65,001–66,000",
  M: "66,001–67,000", N: "67,001–68,000", O: "68,001–69,000", P: "69,001–70,000",
  Q: "70,001–71,000", R: "71,001–72,000", S: "72,001–73,000", T: "73,001–74,000",
  U: "74,001–75,000", V: "over 75,000",
};

// [value, label, months remaining in the period] (i2290 pg 14). Kept as the
// full 12-month season regardless of today's date - utils/tax.js's
// remainingMonths() looks up any of these 12 values by month-first-used, and
// that lookup must keep working for whatever month a return already has on
// file. For the "Month first used" DROPDOWN specifically, use
// visibleMonthOptions() below instead of this array directly.
export const MONTHS = [
  ["2026-07", "July 2026", 12], ["2026-08", "August 2026", 11], ["2026-09", "September 2026", 10],
  ["2026-10", "October 2026", 9], ["2026-11", "November 2026", 8], ["2026-12", "December 2026", 7],
  ["2027-01", "January 2027", 6], ["2027-02", "February 2027", 5], ["2027-03", "March 2027", 4],
  ["2027-04", "April 2027", 3], ["2027-05", "May 2027", 2], ["2027-06", "June 2027", 1],
];

// All 12 months, unfiltered. Mirrors the backend's GET /lookups/months
// (LookupController.months()): visibility is controlled entirely by
// lookup_first_used_months.is_true, not by today's date - this is only the
// unauthenticated-demo/fetch-still-loading fallback for that same endpoint,
// so it must not apply a cap the backend no longer applies.
export const visibleMonthOptions = () => MONTHS;

export const STEPS = [
  "Tax preparer", "Business", "Form", "Trucks", "Prior year", "Credits",
  "Tax summary", "Review", "Pay",
];

export const CREDENTIALS = [
  ["cpa", "CPA"],
  ["ea", "Enrolled agent (EA)"],
  ["attorney", "Attorney"],
  ["afsp", "AFSP"],
  ["none", "Tax preparer (no credential)"],
];

export const BUSINESS_TYPES = [
  ["sole_prop", "Sole proprietorship"],
  ["partnership", "Partnership"],
  ["llc", "LLC"],
  ["corporation", "Corporation"],
  ["s_corp", "S corporation"],
  ["nonprofit", "Non-profit"],
  ["government", "Government"],
  ["other", "Other"],
];

export const THEMES = [
  ["day", "Daylight"],
  ["night", "Night Haul"],
  ["dispatch", "Dispatch"],
];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY",
  "LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH",
  "OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

// Sample returns shown on the dashboard.
export const SAMPLES = [
  { status: "full", biz: "Ray's Hauling LLC", trucks: 3, due: 658, pct: 100, ein: "12-3456789" },
  { status: "half", biz: "Cedar Ridge Logging", trucks: 2, due: 412.5, pct: 55, ein: "45-9981200" },
  { status: "new", biz: "New return", trucks: 0, due: 0, pct: 5, ein: "" },
];

export const blankBiz = () => ({
  name: "", dba: "", taxPreparerId: null, ein: "", ctl: "", care: "", businessType: "", email: "",
  kind: "us", country: "US", countryName: "United States", a1: "", a2: "", city: "", state: "", zip: "", phone: "",
  signingAuthorityName: "", signingAuthorityTitle: "", signingAuthorityPhone: "",
  hasThirdPartyDesignee: false, tpdName: "", tpdPhone: "", tpdPin: "",
});

export const blankPreparer = () => ({
  name: "", ptin: "", credentials: "", email: "", phone: "", ext: "",
  isFirmEmployee: false, firmName: "", firmEin: "",
  kind: "us", country: "US", countryName: "United States", a1: "", a2: "", city: "", state: "", zip: "",
});

// Pre-built seed states for the New / Half / Full dashboard entry points.
export const SEEDS = {
  new: {
    biz: blankBiz(),
    preparer: blankPreparer(),
    trucks: [],
    maxStep: 1,
    step: 1,
  },
  half: {
    biz: {
      name: "Cedar Ridge Logging", dba: "", ein: "45-9981200", ctl: "CEDA", care: "",
      businessType: "llc", email: "office@cedarridgelogging.com", kind: "us", country: "US", countryName: "United States",
      a1: "1420 Mill Creek Rd", a2: "", city: "Eugene", state: "OR", zip: "97402", phone: "(541) 555-0148",
      signingAuthorityName: "Dana Whitfield", signingAuthorityTitle: "Owner", signingAuthorityPhone: "(541) 555-0148",
      hasThirdPartyDesignee: false, tpdName: "", tpdPhone: "", tpdPin: "",
    },
    preparer: {
      name: "Jordan Blake", ptin: "P12345678", credentials: "ea", email: "jordan@blaketax.com",
      phone: "(541) 555-0199", ext: "", isFirmEmployee: true, firmName: "Blake Tax Advisors LLC", firmEin: "45-1234567",
      kind: "us", a1: "220 Willamette St", city: "Eugene", state: "OR", zip: "97401",
    },
    trucks: [
      { vin: "1FUJGLDR9CLBP8834", cat: "V", logging: true, suspended: false },
      { vin: "3AKJGLDV0GSHT1234", cat: "W", logging: false, suspended: true },
    ],
    maxStep: 5,
    step: 5,
  },
  full: {
    biz: {
      name: "Ray's Hauling LLC", dba: "Ray's Hauling", ein: "12-3456789", ctl: "RAYS", care: "",
      businessType: "llc", email: "office@rayshauling.com", kind: "us", country: "US", countryName: "United States",
      a1: "88 Depot St", a2: "", city: "Joliet", state: "IL", zip: "60432", phone: "(815) 555-0110",
      signingAuthorityName: "Ray Delgado", signingAuthorityTitle: "Managing Member", signingAuthorityPhone: "(815) 555-0110",
      hasThirdPartyDesignee: true, tpdName: "Casey Nguyen", tpdPhone: "(815) 555-0177", tpdPin: "48213",
    },
    preparer: {
      name: "Casey Nguyen", ptin: "P98765432", credentials: "cpa", email: "casey@nguyencpa.com",
      phone: "(815) 555-0177", ext: "204", isFirmEmployee: true, firmName: "Nguyen CPA Group", firmEin: "36-7654321",
      kind: "us", a1: "88 Depot St", city: "Joliet", state: "IL", zip: "60432",
    },
    trucks: [
      { vin: "1FUJGLDR9CLBP8834", cat: "V", logging: false, suspended: false },
      { vin: "3AKJGLDV0GSHT1234", cat: "W", logging: false, suspended: true },
      { vin: "1XKDDB9X1MJ123456", cat: "C", logging: true, suspended: false },
    ],
    maxStep: 11,
    step: 9,
  },
};
